import React from 'react';
import { GenericIconProps } from './utils';
import theme from '../utils/theme/theme';

export default function IconWarning(props: GenericIconProps) {
  const { width = 18, height = 15, stroke = theme.colors.black } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 18 15" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-69.000000, -330.000000)"
          stroke={stroke}
          strokeWidth="2"
        >
          <g transform="translate(66.000000, 326.000000)">
            <path d="M10.7588556,5.69136878 L4.61119895,15.8456305 C4.35327437,16.2875632 4.35173441,16.8317191 4.60715364,17.275074 C4.86257287,17.7184288 5.33658761,17.9943913 5.85234333,18 L18.1476567,18 C18.6634124,17.9943913 19.1374271,17.7184288 19.3928464,17.275074 C19.6482656,16.8317191 19.6467256,16.2875632 19.388801,15.8456305 L13.2411444,5.69136878 C12.9779886,5.26213315 12.5074075,5 12,5 C11.4925925,5 11.0220114,5.26213315 10.7588556,5.69136878 Z" />
            <path d="M12,9 L12,13" />
            <path d="M12,14 L12,16" />
          </g>
        </g>
      </g>
    </svg>
  );
}
